import { AnalyticsUtils } from 'utils'
import { FeedbackForm } from 'common-frontend'

export default class ChecksFeedback extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object,
  }

  static propTypes = {
    href: React.PropTypes.string.isRequired,
    featureType: React.PropTypes.object.isRequired,
    featureKey: React.PropTypes.string,
  }

  state = {
    showFollowUpQuestion: false,
  }

  constructor(props) {
    super(props)
  }

  handleFollowUpResponse = response => {
    if (response === 'yes') {
      // To-do: refactor common component for Yes button dynamic behavior
      Object.assign(document.createElement('a'), { target: '_blank', href: 'https://apps.shopify.com/plug-in-seo#modal-show=ReviewListingModal'}).click()
    }

    this.setState({ showFollowUpQuestion: false })
  }

  renderFollowUpQuestion() {
    if (!this.state.showFollowUpQuestion) return null

    return (
      <FeedbackForm
        question="Great! Do you have a minute to leave us a review?"
        buttonTextYes="Sure, I have a minute"
        buttonTextNo="No, thanks"
        onAnswer={this.handleFollowUpResponse}
      />
    )
  }


  render() {
    return (
      <div className="satisfactionSurvey">
        <FeedbackForm
          question="Were these instructions helpful?"
          helpLink={this.props.href}
          buttonTextYes="Yes, they were"
          buttonTextNo="No, I need help"
          repeating={!this.props.featureKey}
          storeKey={`checks-feedback--${this.props.featureKey}`}
          onMount={() => AnalyticsUtils.checksSupportFormViewed(this.props.featureType)}
          onAnswer={answer => {
            AnalyticsUtils.checksSupportFormAnswered(this.props.featureType, answer)
            if (answer === 'yes') this.setState({ showFollowUpQuestion: true })
          }}
        />
        {this.renderFollowUpQuestion()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/checks/ChecksFeedback.js